// src/components/common/NotificationsBell.jsx
import { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import api from '../../lib/api';
import { success } from './Toast';
import { formatDate } from '../../lib/helpers';

export default function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    fetchNotifs();
    const interval = setInterval(fetchNotifs, 30000); // every 30s
    return () => clearInterval(interval);
  }, []);

  const fetchNotifs = async () => {
    try {
      const res = await api.get('/notifications');
      const list = res.data.notifications || res.data;
      setNotifications(list);
      setUnread(res.data.unread_count || list.filter(n => !n.read_at).length);
    } catch (err) {}
  };

  const markAllRead = async () => {
    try {
      await api.post('/notifications/mark-all-read');
      // refresh notifications and unread count
      fetchNotifs();
      success('All notifications marked as read');
    } catch (err) {
      // ignore or handle error as needed
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="relative p-2 hover:bg-gray-100 rounded-full transition"
      >
        <Bell size={24} />
        {unread > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-6 h-6 flex items-center justify-center font-bold">
            {unread > 99 ? '99+' : unread}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-96 bg-white rounded-2xl shadow-2xl border z-50 overflow-hidden">
            <div className="p-5 border-b flex justify-between items-center">
              <h3 className="font-bold text-lg">Notifications</h3>
              {unread > 0 && (
                <button onClick={markAllRead} className="text-primary text-sm hover:underline">
                  Mark all read
                </button>
              )}
            </div>
            <div className="max-h-96 overflow-y-auto">
              {notifications.length === 0 ? (
                <p className="p-8 text-center text-gray-500">No notifications yet</p>
              ) : (
                notifications.slice(0, 10).map(notif => (
                  <div
                    key={notif.id}
                    className={`p-4 border-b hover:bg-gray-50 transition ${!notif.read_at ? 'bg-blue-50' : ''}`}
                  >
                    <p className="font-medium">{notif.title || 'New Notification'}</p>
                    <p className="text-sm text-gray-600 mt-1">{notif.message}</p>
                    <p className="text-xs text-gray-400 mt-2">
                      {notif.created_at}
                    </p>
                  </div>
                ))
              )}
            </div>
            <div className="p-3 bg-gray-50 text-center">
              <button className="text-primary font-medium">View all notifications →</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}